var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-center w-100"},[_c('b-spinner',{staticClass:"align-middle",attrs:{"type":"grow","variant":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }